<template>
    <div class="business-content-main"  v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select
                        v-model="searchData.SId"
                        :loading="loading"
                        class="search-item"
                        size="small"
                        filterable
                        remote
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            >
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">品牌</div>
                    <div class="search-item" style="width: 100px">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">分类</div>
                    <div class="search-item" style="width: 100px">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">滞销天数</div>
                    <div class="flex">
                        <el-select size="small" class="search-item" disabled style="width: 60px" v-model="searchData.Symbol"
                            placeholder="符号">
                            <el-option key=">" label=">" value=">"></el-option>
                        </el-select>
                        <el-input ref="search_5" class="search-item" size="small" style="width: 80px"
                            v-model.trim="searchData.Invent1"></el-input>
                    </div>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button
                    >                    
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SaleTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                    :tableCode="tableCode"
                >
                    <el-table-column
                        type="index"
                        width="50"
                        label="序号"
                    >
                    </el-table-column>
                    <el-table-column
                        width="240px"
                        label="汽配编码"
                        resizable
                        header-align
                        sortable
                        prop="APCode"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="180px"
                        label="汽配名称"
                        resizable
                        header-align
                        prop="GoodName"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="240px"
                        label="适用车型"
                        resizable
                        header-align
                        prop="AutoSerise"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="100px"
                        label="品牌"
                        resizable
                        header-align
                        prop="Brand"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="80px"
                        label="分类"
                        resizable
                        header-align
                        prop="Cate"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="100px"
                        label="在仓数"
                        resizable
                        header-align
                        sortable
                        prop="Inventory"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="成本价格"
                        resizable
                        header-align
                        sortable
                        prop="CostPrice"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="批发价格"
                        resizable
                        header-align
                        sortable
                        prop="Price"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="120px"
                        label="零售价格"
                        resizable
                        header-align
                        sortable
                        prop="MarketPrice"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        width="180px"
                        label="上一次出库日期"
                        resizable
                        header-align
                        prop="OutInvTime"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.OutInvTime != '0001-01-01 00:00:00' ? scope.row.OutInvTime != '1900-01-01 00:00:00' ? scope.row.OutInvTime : '' : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="180px"
                        label="上一次入库日期"
                        resizable
                        header-align
                        prop="InInvTime"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.InInvTime != '0001-01-01 00:00:00' ? scope.row.InInvTime != '1900-01-01 00:00:00' ? scope.row.InInvTime : '' : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="80px"
                        label="滞销天数"
                        resizable
                        prop="UnsalableDays"
                        fixed="right"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>            
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            dateTimes: [],
            warehouseList:[],
            brand: [],
            typeList1: [],
            SaleDialogTitle: '',
            PurchaseDialogTitle: '',
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SId:'',
                SortProp: '',
                SortType: '',
                Symbol:'>',
                Invent1:180,
                page: 1,
                limit: 15
            },
            dialogVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            columnShowSets: [],
            permission: {},
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            exportTotalCount: 0,       
            typeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }     
        };
    },
    created() {
    },
    mounted() {
        this.permission = this.$util.getPermission('AutoPartUnsalableStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getWarehouse();
    },
    watch: {
        dialogVisible(value) {
            if (!value) {
                this.choosedGood = {};
            }
        }
    },
    methods: {
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        // searchGoodsType(key) {
        //     if (![undefined].includes(key)) {
        //         this.typeForm.Page = 1;
        //         this.typeForm.stopLoad = false;
        //         this.typeForm.key = key;
        //         this.typeList1 = [];
        //     }
        //     if (this.typeForm.stopLoad) return;

        //     this.$util
        //         .getEntpApCategoryList(this.typeForm.key, this.typeForm.Page, this.typeForm.Limit)
        //         .then(data => {
        //             if (!data) return;
        //             this.typeForm.stopLoad = data.length < this.typeForm.Limit;
        //             this.typeList1 = [...this.typeList1, ...data];
        //         })
        //         .catch(() => {});
        // },
        searchGoodsType() {
            this.$util
                .searchGoodsType()
                .then(data => {
                    if (!data) return;
                    this.typeList1 = data;
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType('');
            }
        },
        // 重置表单
        resetSearch() {
            let sid = '';
            if(this.warehouseList){
                sid = this.warehouseList[0].WarehouseId;
            }
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                SId:sid,
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                Symbol:'>',
                Invent1:180,
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
        },
        // 关闭弹窗
        closeDialog(edit) {
            this.dialogVisible = false;
            this.choosedGood = {};
            if (edit) {
                this.getTableData();
            }
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/AutoPartUnsalableStat',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        this.tableData=[];
                         this.tableDataLength=0;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    if(this.searchData.page==1)
                        this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        //销售数据
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.Id;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.APId = row.Id;
                this.goodsAnalysisVisible = true;
            }
        },
        // 历史销售
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getWarehouse() {
            this.$util.getWarehouseNotAuth(1).then(data => {
                this.warehouseList = data;
                if(data){
                    this.searchData.SId = data[0].WarehouseId;
                    if(this.tableDataLength === 0)
                        this.getTableData();
                }
                
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 1000;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;
            // let saveLimit = that.tableDataLength;
            let reqData = { ...that.searchData };
            reqData.limit = saveLimit;
            reqData.page = that.currtPage;
            
            that.$util
                .axiosPost({
                    url: '/api/DataStatistics/GetAPUnsalableStatsToExport',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    let data = resp.data;
                    if (that.currtPage == 1) {
                        if (data.totalCount == 0) {
                            that.percentage = 0;
                            that.saveCount = 0;
                            that.currtPage = 1;
                            that.exportTotalCount = 0;
                            that.saveLoading = false;
                            that.showExportMsg = false;
                            that.$util.warningMsg('没有可导出的数据');
                            return;
                        }
                        that.exportTotalCount = data.totalCount;
                    }
                    that.saveCount += data.count;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.exportTotalCount);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.exportTotalCount <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile_post({
                                url: '/api/DataStatistics/ExportAPUnsalableStats',
                                hideLoading:true,
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.exportTotalCount = 0;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            })
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.exportTotalCount = 0;
                    that.saveLoading = false;
                    that.showExportMsg = false;
                });
        },        
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 16.6%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }
    .image-cus {
        width: 25px;
        height: 25px;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>